<template>
	<div>
		<h1>Assignment Of Interventions</h1>

		<InputSelectMulti
			question="What was the ratio of randomization between groups?"
			:options="ratioRandomizationOptions"
			v-model="$tera.project.TrialWizard.ratioRandomization"
			bookmark="randomization-ratio"
		/>

		<i
			>Sequence generation: Method of generating the allocation sequence (eg,
			computer-generated random numbers), and list of any factors for
			stratification. To reduce predictability of a random sequence, details of
			any planned restriction (eg, blocking) should be provided in a separate
			document that is unavailable to those who enrol participants or assign
			interventions</i
		>
		<InputSelectMulti
			question="How was the sequence of participant allocation generated?"
			:options="sequenceGenOptions"
			v-model="$tera.project.TrialWizard.sequenceGen"
			bookmark="participant-allocation"
		/>

		<i
			>Allocation concealment mechanism: Mechanism of implementing the
			allocation sequence (eg, central telephone; sequentially numbered, opaque,
			sealed envelopes), describing any steps to conceal the sequence until
			interventions are assigned</i
		>
		<InputTextSingleLine
			question="How was the allocation of participants concealed?"
			placeholder="e.g. centralised randomisation via a telephone by an independent consultant"
			v-model="$tera.project.TrialWizard.concealment"
			bookmark="participants-concealed"
		/>

		<!--New added-->
		<div class="p-mt-6">
			<i>Mechanism of implementing the allocation sequence</i>
		</div>

		<InputSelectMulti
			question="What was the mechanism of implementing the allocation sequence?"
			:options="mechanismOptions"
			v-model="$tera.project.TrialWizard.mechanism"
			bookmark="allocation-sequence"
		/>

		<InputTextSingleLine
			question="Describe any steps to conceal the sequence until interventions are assigned"
			placeholder="e.g. The laboratory technician performing the assay was blinded to all personal and medical characteristics of the patient"
			v-model="$tera.project.TrialWizard.concealSteps"
			bookmark="sequence-conceal"
		/>
		<!-- <i
			>Blinding: Who will be blinded after assignment to interventions (eg,
			trial participants, care providers, outcome assessors, data analysts), and
			how. If blinded, circumstances under which unblinding is permissible, and
			procedure for revealing a participant's allocated intervention during the
			trial</i
		>
		<InputTextSingleLine
			question="Who generated the allocation sequence?"
			placeholder="e.g. Daily check-ups"
			:value="assignmentOfInterventions.adherenceMaintained"
			@input="updateField('adherenceMaintained', $event)"
		/>

		<InputTextSingleLine
			question="Who enrolled participants in the trial?"
			placeholder="e.g. Daily check-ups"
			:value="assignmentOfInterventions.adherenceMaintained"
			@input="updateField('adherenceMaintained', $event)"
		/>

		<InputTextSingleLine
			question="Who assigned participants to the interventions?"
			placeholder="e.g. Daily check-ups"
			:value="assignmentOfInterventions.adherenceMaintained"
			@input="updateField('adherenceMaintained', $event)"
		/> -->

		<div class="p-mt-6">
			<i
				>Blinding: Who will be blinded after assignment to interventions (eg,
				trial participants, care providers, outcome assessors, data analysts),
				and how. If blinded, circumstances under which unblinding is
				permissible, and procedure for revealing a participant's allocated
				intervention during the trial</i
			>
		</div>

		<InputSelectMulti
			question="The following people were blinded after assignment to interventions"
			:options="blindedPeopleOptions"
			v-model="$tera.project.TrialWizard.blindedPeople"
			bookmark="people-blinded"
		/>

		<InputTextSingleLine
			question="People were blinded using the following method"
			placeholder="e.g. the placebo being identical in shape and color to the intervention pill"
			v-model="$tera.project.TrialWizard.blindedMethod"
			bookmark="blinded-method"
		/>

		<InputSelectMulti
			question="Unblinding was permissible under the following circumstances"
			:options="unblindingOptions"
			v-model="$tera.project.TrialWizard.unblinding"
			bookmark="unblinding"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputAssignmentOfInterventions from "./OutputAssignmentOfInterventions.vue";
import deepstreamMixin from "@/mixins/DeepstreamMixin";

export default {
	mixins: [deepstreamMixin("assignmentOfInterventions")],
	data() {
		return {
			outputComponent: OutputAssignmentOfInterventions,
			ratioRandomizationOptions: [
				{ label: "1:1" },
				{ label: "2:1" },
				{ label: "3:1" }
			],
			sequenceGenOptions: [
				{ label: "blocking" },
				{ label: "minimization" },
				{ label: "stratification" }
			],
			blindedPeopleOptions: [
				{ label: "trial participants" },
				{ label: "care providers" },
				{ label: "data analysts" },
				{ label: "outcome assessors" }
			],
			unblindingOptions: [
				{ label: "serious adverse event" },
				{ label: "physician request" }
			],
			//new added
			mechanismOptions: [
				{ label: "central telephone" },
				{ label: "sequentially numbered" },
				{ label: "opaque" },
				{ label: "sealed envelopes" }
			]
		};
	}
};
</script>
